//export const WS_SERVER_CHAT_URL = 'ws://localhost:8080';
export const WS_SERVER_CHAT_URL = 'wss://gateway.c2d.bfnotion.ru';
export const REST_SERVER_CHAT_URL = 'https://gateway.c2d.bfnotion.ru';
//export const REST_SERVER_CHAT_URL = 'http://localhost:3000';